import Comunication from './Comunication'

class Comunications extends Array {
    constructor(comunications) {
        if (!Array.isArray(comunications)) {
            super()
            return
        }

        const comunicationList = comunications.map(
            ({ id, title, body, attachments, createdAt, readAt, read }) =>
                new Comunication(id, title, body, attachments, createdAt, readAt, read)
        )

        super(...comunicationList)
    }

    push(id, title, body, attachments, createdAt, readAt, read) {
        return super.push(new Comunication(id, title, body, attachments, createdAt, readAt, read))
    }
}

export default Comunications
